import useJwt from "@/libs/auth/jwt/useJwt";

const axios = useJwt.axiosIns;
export const postCode = (data) => axios.post('/api/diagnosis/checkcode', data);
